import ServerBase, { subscribeMsg } from "../server_base";
import ModelData from "../../../public/model_data";
import { NetMsgDataMapClubHall } from "./net_msg_data_map_club_hall";
import AppData from "../../../public/const/app_data";
import { GameManager } from "../../../../manager/game_manager";
import { Hallx } from "./proto_club_hall_notify";
import { club_utils } from "../../../club/club_utils";

const { ccclass, property } = cc._decorator;


@ccclass
export default class ClubHallServer extends ServerBase{

    _maxReconTimes = 10

    onLogin : (data : Hallx.AuthRsp) => void;
    onRoomInfo : (data : Hallx.RoomInfoNotify) => void;
    onBatchRoomInfos : (data : Hallx.BatchRoomInfosNotify) => void;
    onOneRoundGameResult : (data : Hallx.OneRoundGameResultNotify) => void;
    onRoomClosed : (data : Hallx.RoomClosedNotify) => void;
   

    private static _instance : ClubHallServer;
    public static get instance() : ClubHallServer {
        return this._instance;
    }

    onLoad(){
        ClubHallServer._instance = this;
        this.init("ClubHallServer")        
    }  

    connectServer(){
        this.connect(GameManager.clubHallServer + ModelData.instance.password + "");
    }

    

    protected _requestPing() {
        if (this.netClient.netState) {
            let data: Hallx.IIdlePingReq = {
           
            }
            this.model.sendMsg(NetMsgDataMapClubHall.Ping, data);
        }
    }

    protected onConnected(){
                        
        let data: Hallx.IAuthReq = {
            playerId: ModelData.instance.roleData.id,
            token: ModelData.instance.password + "",            
            clubId: club_utils.clubId,
        }
        this.model.sendMsg(NetMsgDataMapClubHall.Auth,data);
    }


    quit(){
     
        let data: Hallx.IQuit = {
           
        }
        this.model.sendMsg(NetMsgDataMapClubHall.Quit,data);
    }


  
    @subscribeMsg(NetMsgDataMapClubHall.Ping)
    private onPing(){        
        this.updatePing();
    }

    @subscribeMsg(NetMsgDataMapClubHall.Auth)
    private onAuth(data : Hallx.AuthRsp){

        console.log(" onAuth ");

        this.startCheckPing()

        if (this.onLogin) {
            this.onLogin(data);            
        }
    }

    @subscribeMsg(NetMsgDataMapClubHall.RoomInfoNotify)
    private onRoomInfoNotify(data : Hallx.RoomInfoNotify){

        console.log(" onRoomInfoNotify ");
        if (this.onRoomInfo) {
            this.onRoomInfo(data);            
        }
    }

    @subscribeMsg(NetMsgDataMapClubHall.BatchRoomInfosNotify)
    private onBatchRoomInfosNotify(data : Hallx.BatchRoomInfosNotify){

        console.log(" onBatchRoomInfosNotify ");
        if (this.onBatchRoomInfos) {
            this.onBatchRoomInfos(data);            
        }
    }

    @subscribeMsg(NetMsgDataMapClubHall.OneRoundGameResultNotify)
    private onOneRoundGameResultNotify(data : Hallx.OneRoundGameResultNotify){

        console.log(" onOneRoundGameResultNotify ");
        if (this.onOneRoundGameResult) {
            this.onOneRoundGameResult(data);            
        }
    }

    @subscribeMsg(NetMsgDataMapClubHall.RoomClosedNotify)
    private onRoomClosedNotify(data : Hallx.RoomClosedNotify){

        console.warn(" onRoomClosedNotify ");
        if (this.onRoomClosed) {
            this.onRoomClosed(data);            
        }
    }

    exit(){

        this.quit();

        this.close();

        this.onLogin = null;
        this.onRoomInfo = null;
        this.onBatchRoomInfos = null;
        this.onOneRoundGameResult = null;
        this.onRoomClosed = null;
    }



    

 
}

